import {useNavigate} from 'react-router-dom';


import * as urlUtils from '../../../../utils/urlUtils';

import {cartConstants} from '../index';


/**
 * @return {(function({string}, {boolean}): null)|*} Go to cart function requiring cartId as parameter
 */
function useGoToActiveCart() {

    const navigate = useNavigate();

    return (cartId, doReplace = false) => {

        const cartUrl = urlUtils.buildPath(
            cartConstants.NAV_PAGE_CART,
            {
                cartId
            }
        );

        if (doReplace) {

            navigate(cartUrl, {replace: true});

            return;
        }

        navigate(cartUrl);
    };
}


export default useGoToActiveCart;
